import { render, staticRenderFns } from "./ProductTable.vue?vue&type=template&id=2c9caa3b&scoped=true&"
import script from "./ProductTable.vue?vue&type=script&lang=js&"
export * from "./ProductTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductTable.vue?vue&type=style&index=0&id=2c9caa3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9caa3b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
